module.exports = __webpack_public_path__ + "img/list03.de091502.png";